import { render, staticRenderFns } from "./SiteIcon.vue?vue&type=template&id=76c39532&scoped=true&"
import script from "./SiteIcon.vue?vue&type=script&lang=js&"
export * from "./SiteIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c39532",
  null
  
)

export default component.exports